import { Link } from "react-router-dom";

import porkNikumanMenuImage from '../../../assets/images/resource/porkNikumanMenu.webp'
import chickenNikumanImage from '../../../assets/images/resource/chickenNikumanMenu.webp'
import veggieNikumanImage from '../../../assets/images/resource/veggieNikumanMenu.webp'
import softshellCrabNikumanMenuImage from '../../../assets/images/resource/softshellCrabNikumanMenu.webp'


function NikumanMenu() {

  return (
    <>
      <section className="menu-two">
          <div className="auto-container">
            <div className="title-box centered">
              <h2>Nikuman</h2>
            </div>
            <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={porkNikumanMenuImage} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Pork Nikuman</Link><span className="s-info">CONTAIN PEANUT</span>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$7.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Steamed soft bun served with homemade pork chashu, lettuce, cucumber, cilantro & sauce
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={chickenNikumanImage} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                          Chicken Nikuman
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$7.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                      Steamed soft bun served with crispy chicken, cucumber, red onion, cilantro & homemade spicy mayo
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={veggieNikumanImage} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                          Veggie Nikuman
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$7.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                      Steamed soft bun served with grilled assorted vegetables, shiso tempura & homemade spicy mayo
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={softshellCrabNikumanMenuImage} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Softshell Crab Nikuman<span className="s-info">2 PCS.</span></Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$16.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                      Steamed soft bun served with crispy softshell crab, lettuce, red onion & mentai sauce
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
      </section>
    </>
  );
}

export default NikumanMenu;
